(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-lp-root]');
    if (!root) return;

    var hero = document.getElementById('top');
    var bar = document.querySelector('[data-lp-persistent]');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-reveal]').forEach(function (element) {
      if (!('IntersectionObserver' in window)) {
        element.classList.add('is-visible');
        return;
      }
      var revealObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      revealObserver.observe(element);
    });

    if (hero && bar) {
      var setBar = function (visible) {
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          setBar(!entries[0].isIntersecting);
        }, { threshold: 0 }).observe(hero);
      } else {
        var updateBar = function () { setBar(hero.getBoundingClientRect().bottom <= 0); };
        window.addEventListener('scroll', updateBar, { passive: true });
        updateBar();
      }
    }

    document.addEventListener('click', function (event) {
      var cta = event.target.closest('[data-cta]');
      if (!cta) return;
      var target = cta.getAttribute('href');
      if (target && target.charAt(0) === '#' && !cta.hasAttribute('data-cart-add')) {
        var destination = document.querySelector(target);
        if (destination) {
          event.preventDefault();
          destination.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
          history.replaceState(null, '', target);
        }
      }
    });

    var host = window.location.hostname.replace(/^www\./, '');
    var isProduction = host === 'progurt.com.au' || host === 'progurt.com';
    if (!isProduction || typeof window.safeGtag !== 'function') return;

    var dimensions = {
      lp: root.dataset.lp,
      market: root.dataset.market,
      hero_variant: root.dataset.heroVariant
    };
    window.safeGtag('event', 'lp_view', dimensions);

    if (typeof window.clarity === 'function') {
      window.clarity('set', 'funnel_page', dimensions.lp);
      window.clarity('set', 'hero_variant', dimensions.hero_variant);
      window.clarity('set', 'market', dimensions.market);
    }

    document.addEventListener('click', function (event) {
      var cta = event.target.closest('[data-cta]');
      if (!cta) return;
      window.safeGtag('event', 'lp_cta_click', Object.assign({}, dimensions, {
        cta_position: cta.dataset.cta
      }));
    });

    if (!('IntersectionObserver' in window)) return;
    var sectionObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var section = entry.target.dataset.lpSection;
        var key = ['lp-section', dimensions.lp, dimensions.hero_variant, section].join(':');
        try {
          if (sessionStorage.getItem(key)) {
            observer.unobserve(entry.target);
            return;
          }
          sessionStorage.setItem(key, '1');
        } catch (error) {}
        window.safeGtag('event', 'lp_section_view', Object.assign({}, dimensions, { section: section }));
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -12% 0px' });
    document.querySelectorAll('[data-lp-section]').forEach(function (section) {
      sectionObserver.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
